<template>
    <div class="modal-content editStake-modal">
        <div class="modal-header">
            <h5>{{ $t('edit-stake', 'Edit Stake')}}</h5>
        </div>
        <hr />
        <div class="modal-body edit_stake_modal_body">
            <div v-if="stake" class="exch-cashout-body-center">
                <div class="amount-value">
                    <div v-for="(i, index) in 4" :key="index" class="stakeed-item">
                        <input v-model="stake[i-1]" maxlength="8" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)" class="btn-thm m-auto">
                    </div>
                </div>
            </div>
            <div class="header-but wallet_edit_footer info-footer">
                <button type="button" ref="close_button" class="thm-but thm-bor-but" data-bs-dismiss="modal" @click="resetChips()">{{ $t('cancel','Cancel')}}</button>
                <a class="thm-but save-notification" @click="callChangeStakeValue()">{{ $t('save','Save')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WalletStackModal",
    props:{
        stakes : Object,
        getStakes: Function
    },
    data() {
        return {
            stake: JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes))
        }
    },
    emits: ['close-stake-modal','save-btn'],
    mounted() {
        this.resetChips();
    },
    methods: {
        callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast('Stake value must be between 100 to 1Cr.')
                return

            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$successToast('Saved Successfully');
            this.$helper.closeModal('editStakeModal');
        },
        resetChips() {
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
    }
};
</script>